import angular from 'angular';

export default angular.module('app.services.campaignTargetingsUtils', [])
  .service('campaignTargetingsConstants', () => {
    return {
      transformFrequencyCaps(data) {
        const defaultFrequencyRule = (campaignId, event, times, intervalInHours) => ({
          level: 'campaign',
          level_entity_id: campaignId,
          key: 'campaign_id',
          event,
          times,
          interval_in_hours: intervalInHours
        })

        const frequencyClickRule =
            _.chain(data.frequency_cap_rules)
            .filter(f => f.event === 'click')
            .map(({interval_in_sec, ...rest}) => ({interval_in_hours: _.round(interval_in_sec / 3600, 1), ...rest}))
            .value();
        const frequencyImpressionRule =
            _.chain(data.frequency_cap_rules)
            .filter(f => f.event === 'impression')
            .map(({interval_in_sec, ...rest}) => ({interval_in_hours: _.round(interval_in_sec / 3600, 1), ...rest}))
            .value();

        let rule;
        switch (frequencyClickRule.length) {
          case 0:
            rule = [defaultFrequencyRule(data.id, 'click',1, 0.5), defaultFrequencyRule(data.id, 'click',null, null)];
            break;
          case 1:
            rule = [...frequencyClickRule, defaultFrequencyRule(data.id, 'click',null, null)];
            break;
          default:
            rule = frequencyClickRule;
            break;
        }

        let impression;
        switch (frequencyImpressionRule.length) {
          case 0:
            impression = [defaultFrequencyRule(data.id, 'impression',8, 24), defaultFrequencyRule(data.id, 'impression',1, 0.5)];
            break;
          case 1:
            impression = [...frequencyImpressionRule, defaultFrequencyRule(data.id, 'impression',null, null)];
            break;
          default:
            impression = frequencyImpressionRule;
            break;
        }
        return {
          rule,
          impression,
        }
      }
    };
  });



/** WEBPACK FOOTER **
 ** ./src/services/campaignTargetingsConstants.js
 **/